<template>
	<Modal
		id="modal-811-reminder"
		:is-open="isModalOpen('modal-811-reminder')"
		max-width="max-w-md"
		title-classes="text-2xl font-bold text-center dark:text-white"
		hide-footer
		@on-cancel="closeModal"
	>
		<template #title>
			{{ $t('811.title') }}
		</template>
		<template #body>
			<div class="px-4 py-4 text-center dark:text-white space-y-4">
				<div class="flex justify-center mb-4">
					<div class="bg-mx-orange/10 p-4 rounded-full">
						<ExclamationTriangleIcon class="h-12 w-12 text-mx-orange" />
					</div>
				</div>

				<p class="text-lg">
					{{ $t('811.modal-message') }}
				</p>

				<div class="pt-4">
					<FormButton
						:button-text="$t('811.modal-button')"
						class="w-full"
						@click="navigateToPage"
					/>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import { useModal } from '@/composables/useModal'

const { closeModal, isModalOpen } = useModal()

const navigateToPage = () => {
	closeModal()
	navigateTo('/811')
}
</script>
